import { ReactNode } from 'react';
import { Inline } from '../../../design-system/inline/inline';
import { TabsList, Tabs as TabsRoot, TabsTrigger } from '../../../design-system/tabs/tabs-primitives';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';

type TabValue = 'PAYROLLS' | 'EMPLOYEES';

type TabCounterConfig =
  | {
      showCounter: false;
    }
  | {
      showCounter: true;
      count: number;
    };

export type TabTrigger = {
  value: TabValue;
  counterConfig: TabCounterConfig;
};

type PayrollSectionTabsProps = {
  triggers: TabTrigger[];
  children: ReactNode;
};

export const PayrollSectionTabs = ({ triggers, children }: PayrollSectionTabsProps) => {
  return (
    <TabsRoot defaultValue="PAYROLLS">
      <TabsList className="mb-5 rounded-none px-0">
        <Inline space={8}>
          {triggers.map((trigger) => {
            const tabTriggerText = getTabTriggerText(trigger.value);

            return (
              <TabsTrigger
                key={trigger.value}
                value={trigger.value}
                className="rounded-none px-0 py-0 text-seapoint-gray outline-offset-8 data-[state=active]:bg-white"
              >
                <Inline space={2}>
                  <p className="border-b-2 border-b-transparent text-base font-medium leading-6 tracking-tight text-seapoint-gray group-data-[state=active]:border-b-seapoint-yellow group-data-[state=active]:text-black">
                    {tabTriggerText}
                  </p>

                  {trigger.counterConfig.showCounter && (
                    <div className="h-4 w-4 rounded-full bg-seapoint-gray-background-modal p-0.5">
                      <p className="text-[9px] leading-3 tracking-tight text-black">{trigger.counterConfig.count}</p>
                    </div>
                  )}
                </Inline>
              </TabsTrigger>
            );
          })}
        </Inline>
      </TabsList>

      {children}
    </TabsRoot>
  );
};

const getTabTriggerText = (tabValue: TabValue) => {
  switch (tabValue) {
    case 'PAYROLLS':
      return 'Payrolls';
    case 'EMPLOYEES':
      return 'Employees';
    default:
      return exhaustiveCheck(tabValue);
  }
};
